import './datadogAnalytics';
import React, { useContext, useEffect } from "react";
import {
  enLanguage,
  esLanguage,
  useLanguage,
} from "./contextes/LanguageContext";
import { CustomThemeContext } from "./contextes/ThemeContext";
import { Calibration } from "./deviceCalibration/";
import enMessages from "./intl/en.json";
import esMessages from "./intl/es.json";
import { DEFAULT_THEME } from "./themes/theme";
import { createBrowserHistory } from "history";
import { Route, Router, Switch } from "react-router";
import { IntlProvider } from "react-intl";
import "./App.scss";

const messages = {
  [enLanguage]: enMessages,
  [esLanguage]: esMessages,
};

const history = createBrowserHistory();

export const App = () => {
  const { language } = useLanguage();
  const { setTheme } = useContext(CustomThemeContext);
  const themeName = DEFAULT_THEME;
  useEffect(() => {
    if (themeName) {
      setTheme(themeName);
    }
  }, [themeName]);
  return (
    <IntlProvider locale={language} messages={messages[language]}>
      <Router history={history}>
        <Switch>
          <Route
            exact
            path="/organization/:orgId/device/:deviceImei/calibration"
            component={Calibration}
          />
        </Switch>
      </Router>
    </IntlProvider>
  );
};
